import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, Input, Label, Spinner } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./assets/css/WhiteLabel.css";

const WhiteLabel = () => {
    document.title = "White Label | MEDR";

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [customDomains, setCustomDomains] = useState([]);
    const [selectedDomain, setSelectedDomain] = useState(null);
    const [formData, setFormData] = useState({
        domain: "",
        title: "",
        background_color: "#020626",
        color_primary: "#05dac3",
        logo: "",
        small_logo: "",
        logo_white: "",
        favicon: "",
        loading_icon: "",
        background_login: "",
        background_image_login: "",
        title_footer: "",
        company_url_footer: "",
        logo_login_width: 90,
        logo_sidebar_width: 30,
        logo_sidebar_sm_width: 35,
        external_user_registration: false,
    });

    useEffect(() => {
        fetchCustomDomains();
    }, []);

    const fetchCustomDomains = async () => {
        setLoading(true);
        try {
            const response = await ApiService.send(
                "get",
                `${process.env.REACT_APP_URL_API}custom-domain/my`,
                {},
                true
            );
            const { data } = ApiService.handleApiResponse(response);

            if (data && data.length > 0) {
                setCustomDomains(data);
                // Seleciona o primeiro domínio por padrão
                selectDomain(data[0]);
            } else {
                setCustomDomains([]);
                setSelectedDomain(null);
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const selectDomain = (domain) => {
        setSelectedDomain(domain);
        setFormData({
            domain: domain.domain || "",
            title: domain.title || "",
            background_color: domain.background_color || "#020626",
            color_primary: domain.color_primary || "#05dac3",
            logo: domain.logo || "",
            small_logo: domain.small_logo || "",
            logo_white: domain.logo_white || "",
            favicon: domain.favicon || "",
            loading_icon: domain.loading_icon || "",
            background_login: domain.background_login || "",
            background_image_login: domain.background_image_login || "",
            title_footer: domain.title_footer || "",
            company_url_footer: domain.company_url_footer || "",
            logo_login_width: domain.logo_login_width || 90,
            logo_sidebar_width: domain.logo_sidebar_width || 30,
            logo_sidebar_sm_width: domain.logo_sidebar_sm_width || 35,
            external_user_registration: domain.external_user_registration || false,
        });
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = async () => {
        if (!selectedDomain) return;

        setSaving(true);
        try {
            const response = await ApiService.send(
                "put",
                `${process.env.REACT_APP_URL_API}custom-domain/my/${selectedDomain.id}`,
                formData,
                true
            );
            ApiService.handleApiMessage(response);
            fetchCustomDomains();
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className="page-content white-label-page">
                <Container fluid>
                    <BreadCrumb title="White Label" pageTitle="Configurações" />
                    <Row>
                        <Col md={3}>
                            <Card>
                                <CardBody>
                                    <Skeleton height={40} className="mb-3" />
                                    <Skeleton height={60} className="mb-2" />
                                    <Skeleton height={60} className="mb-2" />
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card>
                                <CardBody>
                                    <Skeleton height={40} className="mb-3" />
                                    <Skeleton height={40} className="mb-3" />
                                    <Skeleton height={100} className="mb-3" />
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={3}>
                            <Card>
                                <CardBody>
                                    <Skeleton height={200} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    if (customDomains.length === 0) {
        return (
            <div className="page-content white-label-page">
                <Container fluid>
                    <BreadCrumb title="White Label" pageTitle="Configurações" />
                    <Row>
                        <Col md={12}>
                            <Card>
                                <CardBody className="no-domain-card">
                                    <i className="ri-paint-brush-line"></i>
                                    <h4>Nenhum domínio customizado associado</h4>
                                    <p className="text-muted">
                                        Entre em contato com o suporte para configurar seu domínio personalizado.
                                    </p>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    return (
        <div className="page-content white-label-page">
            <Container fluid>
                <BreadCrumb title="White Label" pageTitle="Configurações" />
                <Row>
                    {/* Lista de Domínios */}
                    <Col md={3}>
                        <Card>
                            <CardBody>
                                <h5 className="mb-3">
                                    <i className="ri-global-line me-2"></i>
                                    Meus Domínios ({customDomains.length})
                                </h5>
                                <div className="domain-list">
                                    {customDomains.map((domain) => (
                                        <div
                                            key={domain.id}
                                            className={`domain-item p-3 mb-2 rounded cursor-pointer ${
                                                selectedDomain?.id === domain.id ? "active" : ""
                                            }`}
                                            onClick={() => selectDomain(domain)}
                                            style={{
                                                background: selectedDomain?.id === domain.id ? "#e7f1ff" : "#f8f9fa",
                                                border: selectedDomain?.id === domain.id ? "2px solid #0d6efd" : "1px solid #e9ecef",
                                                cursor: "pointer",
                                            }}
                                        >
                                            <div className="d-flex align-items-center">
                                                {domain.favicon && (
                                                    <img
                                                        src={domain.favicon}
                                                        alt=""
                                                        className="me-2"
                                                        style={{ width: 20, height: 20 }}
                                                        onError={(e) => (e.target.style.display = "none")}
                                                    />
                                                )}
                                                <div>
                                                    <strong className="d-block" style={{ fontSize: 14 }}>
                                                        {domain.title || "Sem título"}
                                                    </strong>
                                                    <small className="text-muted">{domain.domain}</small>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                    {/* Formulário de Edição */}
                    <Col md={6}>
                        {selectedDomain && (
                            <>
                                {/* Informações Básicas */}
                                <div className="form-section">
                                    <h5>
                                        <i className="ri-global-line me-2"></i>
                                        Informações Básicas
                                    </h5>
                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label htmlFor="domain">Domínio</Label>
                                                <Input
                                                    type="text"
                                                    id="domain"
                                                    name="domain"
                                                    value={formData.domain}
                                                    onChange={handleChange}
                                                    placeholder="seudominio.com.br"
                                                />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label htmlFor="title">Título da Página</Label>
                                                <Input
                                                    type="text"
                                                    id="title"
                                                    name="title"
                                                    value={formData.title}
                                                    onChange={handleChange}
                                                    placeholder="Nome da sua empresa"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>

                                {/* Cores */}
                                <div className="form-section">
                                    <h5>
                                        <i className="ri-palette-line me-2"></i>
                                        Cores
                                    </h5>
                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label htmlFor="background_color">Cor de Fundo</Label>
                                                <div className="color-input-wrapper">
                                                    <input
                                                        type="color"
                                                        id="background_color"
                                                        name="background_color"
                                                        value={formData.background_color}
                                                        onChange={handleChange}
                                                    />
                                                    <Input
                                                        type="text"
                                                        value={formData.background_color}
                                                        onChange={handleChange}
                                                        name="background_color"
                                                        placeholder="#020626"
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label htmlFor="color_primary">Cor Primária</Label>
                                                <div className="color-input-wrapper">
                                                    <input
                                                        type="color"
                                                        id="color_primary"
                                                        name="color_primary"
                                                        value={formData.color_primary}
                                                        onChange={handleChange}
                                                    />
                                                    <Input
                                                        type="text"
                                                        value={formData.color_primary}
                                                        onChange={handleChange}
                                                        name="color_primary"
                                                        placeholder="#05dac3"
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <Label htmlFor="background_login">Gradiente/Cor do Login</Label>
                                                <Input
                                                    type="text"
                                                    id="background_login"
                                                    name="background_login"
                                                    value={formData.background_login}
                                                    onChange={handleChange}
                                                    placeholder="linear-gradient(180deg, #020626, #05dac3)"
                                                />
                                                <small className="text-muted">
                                                    Ex: linear-gradient(180deg, #020626, #05dac3) ou #000000
                                                </small>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>

                                {/* Logos */}
                                <div className="form-section">
                                    <h5>
                                        <i className="ri-image-line me-2"></i>
                                        Logos
                                    </h5>
                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label htmlFor="logo">Logo Principal</Label>
                                                <Input
                                                    type="text"
                                                    id="logo"
                                                    name="logo"
                                                    value={formData.logo}
                                                    onChange={handleChange}
                                                    placeholder="https://..."
                                                />
                                                {formData.logo && (
                                                    <div className="mt-2">
                                                        <img
                                                            src={formData.logo}
                                                            alt="Logo"
                                                            className="logo-preview"
                                                            onError={(e) => (e.target.style.display = "none")}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label htmlFor="logo_white">Logo Branca (Login)</Label>
                                                <Input
                                                    type="text"
                                                    id="logo_white"
                                                    name="logo_white"
                                                    value={formData.logo_white}
                                                    onChange={handleChange}
                                                    placeholder="https://..."
                                                />
                                                {formData.logo_white && (
                                                    <div className="mt-2" style={{ background: "#333", padding: "10px", borderRadius: "4px" }}>
                                                        <img
                                                            src={formData.logo_white}
                                                            alt="Logo Branca"
                                                            className="logo-preview"
                                                            onError={(e) => (e.target.style.display = "none")}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label htmlFor="small_logo">Logo Pequena (Sidebar)</Label>
                                                <Input
                                                    type="text"
                                                    id="small_logo"
                                                    name="small_logo"
                                                    value={formData.small_logo}
                                                    onChange={handleChange}
                                                    placeholder="https://..."
                                                />
                                                {formData.small_logo && (
                                                    <div className="mt-2">
                                                        <img
                                                            src={formData.small_logo}
                                                            alt="Logo Pequena"
                                                            style={{ maxWidth: "50px", maxHeight: "50px" }}
                                                            onError={(e) => (e.target.style.display = "none")}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label htmlFor="favicon">Favicon</Label>
                                                <Input
                                                    type="text"
                                                    id="favicon"
                                                    name="favicon"
                                                    value={formData.favicon}
                                                    onChange={handleChange}
                                                    placeholder="https://..."
                                                />
                                                {formData.favicon && (
                                                    <div className="mt-2">
                                                        <img
                                                            src={formData.favicon}
                                                            alt="Favicon"
                                                            className="favicon-preview"
                                                            onError={(e) => (e.target.style.display = "none")}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label htmlFor="loading_icon">Ícone de Carregamento</Label>
                                                <Input
                                                    type="text"
                                                    id="loading_icon"
                                                    name="loading_icon"
                                                    value={formData.loading_icon}
                                                    onChange={handleChange}
                                                    placeholder="https://..."
                                                />
                                                {formData.loading_icon && (
                                                    <div className="mt-2">
                                                        <img
                                                            src={formData.loading_icon}
                                                            alt="Loading"
                                                            style={{ maxWidth: "50px", maxHeight: "50px" }}
                                                            onError={(e) => (e.target.style.display = "none")}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label htmlFor="background_image_login">Imagem de Fundo do Login</Label>
                                                <Input
                                                    type="text"
                                                    id="background_image_login"
                                                    name="background_image_login"
                                                    value={formData.background_image_login}
                                                    onChange={handleChange}
                                                    placeholder="https://..."
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>

                                {/* Tamanhos de Logo */}
                                <div className="form-section">
                                    <h5>
                                        <i className="ri-ruler-line me-2"></i>
                                        Tamanhos de Logo
                                    </h5>
                                    <Row>
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <Label htmlFor="logo_login_width">Largura Logo Login (px)</Label>
                                                <Input
                                                    type="number"
                                                    id="logo_login_width"
                                                    name="logo_login_width"
                                                    value={formData.logo_login_width}
                                                    onChange={handleChange}
                                                    min={10}
                                                    max={500}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <Label htmlFor="logo_sidebar_width">Largura Logo Sidebar (px)</Label>
                                                <Input
                                                    type="number"
                                                    id="logo_sidebar_width"
                                                    name="logo_sidebar_width"
                                                    value={formData.logo_sidebar_width}
                                                    onChange={handleChange}
                                                    min={10}
                                                    max={200}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <Label htmlFor="logo_sidebar_sm_width">Largura Logo Sidebar Sm (px)</Label>
                                                <Input
                                                    type="number"
                                                    id="logo_sidebar_sm_width"
                                                    name="logo_sidebar_sm_width"
                                                    value={formData.logo_sidebar_sm_width}
                                                    onChange={handleChange}
                                                    min={10}
                                                    max={100}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>

                                {/* Footer */}
                                <div className="form-section">
                                    <h5>
                                        <i className="ri-layout-bottom-line me-2"></i>
                                        Rodapé
                                    </h5>
                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label htmlFor="title_footer">Título do Rodapé</Label>
                                                <Input
                                                    type="text"
                                                    id="title_footer"
                                                    name="title_footer"
                                                    value={formData.title_footer}
                                                    onChange={handleChange}
                                                    placeholder="Nome da empresa"
                                                />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label htmlFor="company_url_footer">URL da Empresa (Rodapé)</Label>
                                                <Input
                                                    type="text"
                                                    id="company_url_footer"
                                                    name="company_url_footer"
                                                    value={formData.company_url_footer}
                                                    onChange={handleChange}
                                                    placeholder="https://suaempresa.com.br"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>

                                {/* Configurações */}
                                <div className="form-section">
                                    <h5>
                                        <i className="ri-settings-3-line me-2"></i>
                                        Configurações
                                    </h5>
                                    <Row>
                                        <Col md={12}>
                                            <div className="form-check form-switch mb-3">
                                                <Input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="external_user_registration"
                                                    name="external_user_registration"
                                                    checked={formData.external_user_registration}
                                                    onChange={handleChange}
                                                />
                                                <Label className="form-check-label" htmlFor="external_user_registration">
                                                    Permitir registro de usuários externos
                                                </Label>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>

                                {/* Botão Salvar */}
                                <div className="text-end mb-4">
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-lg"
                                        onClick={handleSubmit}
                                        disabled={saving}
                                    >
                                        {saving ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                Salvando...
                                            </>
                                        ) : (
                                            <>
                                                <i className="ri-save-line me-2"></i>
                                                Salvar Alterações
                                            </>
                                        )}
                                    </button>
                                </div>
                            </>
                        )}
                    </Col>

                    {/* Preview Sidebar */}
                    <Col md={3}>
                        {selectedDomain && (
                            <div className="preview-sidebar">
                                <Card>
                                    <CardBody>
                                        <h5 className="mb-3">
                                            <i className="ri-eye-line me-2"></i>
                                            Preview
                                        </h5>

                                        {/* Preview do fundo de login */}
                                        <div className="mb-4">
                                            <Label className="text-muted small">Fundo do Login</Label>
                                            <div
                                                className="background-preview"
                                                style={{
                                                    background: formData.background_login || formData.background_color,
                                                    backgroundImage: formData.background_image_login
                                                        ? `url(${formData.background_image_login})`
                                                        : undefined,
                                                    backgroundSize: "cover",
                                                    backgroundPosition: "center",
                                                }}
                                            >
                                                {formData.logo_white && (
                                                    <img
                                                        src={formData.logo_white}
                                                        alt="Logo"
                                                        style={{
                                                            maxWidth: `${formData.logo_login_width}%`,
                                                            maxHeight: "80px",
                                                        }}
                                                        onError={(e) => (e.target.style.display = "none")}
                                                    />
                                                )}
                                            </div>
                                        </div>

                                        {/* Preview das cores */}
                                        <div className="mb-4">
                                            <Label className="text-muted small">Cores</Label>
                                            <div className="d-flex gap-3">
                                                <div className="text-center">
                                                    <div
                                                        className="color-preview mb-1"
                                                        style={{ background: formData.background_color }}
                                                    ></div>
                                                    <small className="text-muted">Fundo</small>
                                                </div>
                                                <div className="text-center">
                                                    <div
                                                        className="color-preview mb-1"
                                                        style={{ background: formData.color_primary }}
                                                    ></div>
                                                    <small className="text-muted">Primária</small>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Preview das logos */}
                                        {formData.logo && (
                                            <div className="mb-4">
                                                <Label className="text-muted small">Logo Principal</Label>
                                                <div className="preview-card p-3">
                                                    <img
                                                        src={formData.logo}
                                                        alt="Logo"
                                                        className="logo-preview"
                                                        onError={(e) => (e.target.style.display = "none")}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {/* Info */}
                                        <div className="alert alert-info">
                                            <i className="ri-information-line me-2"></i>
                                            <small>
                                                As alterações serão aplicadas após salvar e podem levar alguns minutos para
                                                refletir em todo o sistema.
                                            </small>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default WhiteLabel;
